export const PLANS = {
  FREE: 'free',
  STANDARD: 'standard',
  PLUS: 'plus',
  PROFESSIONAL: 'professional',
};

export const normalizePlan = (plan) => {
  if (!plan) return PLANS.FREE;
  const lower = String(plan).toLowerCase();
  return Object.values(PLANS).includes(lower) ? lower : PLANS.STANDARD;
};

// Copy/pricing for each plan. Feature lists reflect the actual gating in
// App.jsx's PlanProtectedRoute (rubric-generator: plus+professional;
// cohorts & comparison: professional only) plus the session-phase limit
// on Free.
export const PLAN_DETAILS = {
  [PLANS.FREE]: {
    badge: 'Fr',
    name: 'Free',
    tagline: '',
    price: 0,
    isCustomPrice: false,
    features: ['Unlimted sessions (Empathy phase only)', 'Session reports'],
    cta: 'Switch to Free',
    highlight: false,
  },
  [PLANS.STANDARD]: {
    badge: 'St',
    name: 'Standard',
    tagline: '',
    price: 0.99,
    isCustomPrice: false,
    features: ['Unlimited session (All phases)', 'Session reports'],
    cta: 'Upgrade to Standard',
    highlight: false,
  },
  [PLANS.PLUS]: {
    badge: 'Pl',
    name: 'Plus',
    tagline: '',
    price: 2.99,
    isCustomPrice: false,
    features: ['Everything in Standard', 'Rubric generator', 'Chatbot access'],
    cta: 'Upgrade to Plus',
    highlight: true,
  },
  [PLANS.PROFESSIONAL]: {
    badge: 'Pr',
    name: 'Professional',
    tagline: '',
    price: null,
    isCustomPrice: true,
    features: ['Everything in Plus', 'Cohort management & reports', 'Comparison tool', 'Priority support'],
    cta: 'Request a quote',
    highlight: false,
  },
};

export const PLAN_ORDER = [PLANS.FREE, PLANS.STANDARD, PLANS.PLUS, PLANS.PROFESSIONAL];